import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dialogResourceMixin from '@/mixins/dialog/resource';

/**
 * 选择服务项目下拉组件
 */
export default {
  mixins: [dialogResourceMixin],
  props: {
    value: {
      type: String | Number,
      default: null
    },
    placeholder: {
      type: String,
      default: '服务项目'
    },
    // 是否允许清除，默认true
    clearable: {
      type: Boolean,
      default: true
    },
    filterable: {
      type: Boolean,
      default: true
    },
    // 是否组件自动控制禁用状态，默认false
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否初始化下拉选项，默认true
    autoInitOptions: {
      type: Boolean,
      default: true
    },
    // 是否初始化选中，默认false
    autoInitValue: {
      type: Boolean,
      default: false
    },
    companyId: {
      type: String,
      default: null
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(value) {
        this.formData.areaId = value;
      }
    },
    // 根据 autoInitValue 判断是否需要默认选中
    areaDict: {
      immediate: true,
      handler: function handler(val) {
        if (this.autoInitValue) {
          if (val && val.length > 0) {
            this.formData.areaId = val[0].value;
            this.onInit(val[0].value);
          }
        }
      }
    },
    companyId: {
      handler: function handler(val) {
        var _this = this;
        this.$nextTick(function () {
          _this.initDialogAreaDict({
            companyId: val
          });
        });
      }
    }
  },
  data: function data() {
    return {
      formData: {
        areaId: null
      }
    };
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!this.autoInitOptions) {
              _context.next = 4;
              break;
            }
            _context.next = 3;
            return this.initDialogAreaDict({
              companyId: this.companyId
            });
          case 3:
            this.$emit('autoInitOptions', this.areaDict);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  methods: {
    onInit: function onInit(val) {
      this.$emit('input', val);
      this.$emit('init', val);
    },
    onChange: function onChange(val) {
      this.$emit('input', val);
      this.$emit('change', val);
    },
    getSelectedOption: function getSelectedOption() {
      return this.$refs['selector'].getSelectedOption();
    }
  }
};